import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  static instance: any;

  constructor() {}

  private userData = new BehaviorSubject<any>(null);

  /* static createInstance() {
    const userService = new UserService();
    return userService;
  }

  static getInstance() {
    if (!this.instance) {
      this.instance = this.createInstance();
      return this.instance;
    }
    return this.instance;
  } */

  setUserData(data: string) {
    this.userData.next(data);
  }

  getUserData(): Observable<any> {
    return this.userData.asObservable();
  }
}
